import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import PageMeta from "@/components/feature/PageMeta";
import SectionHeader from "@/components/base/SectionHeader";
import PosterGrid from "@/components/base/PosterGrid";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntry from "@/pages/home/components/CategoryEntry";
import { getHot, getLatest } from "@/utils/catalog";

const features = [
  {
    icon: "ri-file-text-line",
    title: "中文字幕齐全",
    desc: "站内影片均以中文字幕版本整理，信息页标注语言与片长，找片不再靠猜。",
  },
  {
    icon: "ri-layout-grid-line",
    title: "分类与筛选清晰",
    desc: "按电影、电视剧归类，再按地区、年份、题材逐层筛选，缩小小范围更快。",
  },
  {
    icon: "ri-user-star-line",
    title: "收藏即点即存",
    desc: "喜欢的作品点一下即可收藏，记录保存在本地浏览器，下次打开依然在。",
  },
];

export default function Home() {
  const latestMovies = getLatest("movie", 12);
  const latestTv = getLatest("tv", 12);
  const hotTitles = getHot(12);

  return (
    <Layout flush>
      <PageMeta
        title="中文字幕在线免费看 - 高清中文字幕影视在线播放平台"
        description="中文字幕在线免费看网站提供丰富的中文字幕电影和电视剧资源，涵盖多种类型，满足用户在线观看需求，方便快捷地观看最新影视作品。"
        keywords="中文字幕在线免费看,中文字幕电影,在线观看电影,电视剧在线观看,高清影视,影视播放平台,免费视频影视"
      />

      <HeroCarousel />
      <CategoryEntry />

      <section className="px-4 pb-10 md:px-8">
        <SectionHeader
          title="最新电影推荐"
          subtitle="近期上线与口碑新作，按年份由新到旧排列"
          to="/category/movie"
          linkLabel="进入电影频道"
        />
        <PosterGrid items={latestMovies} />
      </section>

      <section className="bg-background-100 px-4 py-10 md:px-8">
        <SectionHeader
          title="最新电视剧推荐"
          subtitle="热播连载与经典剧集，中文字幕同步整理"
          to="/category/tv"
          linkLabel="进入电视剧频道"
        />
        <PosterGrid items={latestTv} />
      </section>

      <section className="px-4 py-10 md:px-8">
        <SectionHeader
          title="热门影视精选"
          subtitle="依据站内播放热度排序，挑片不用纠结"
          to="/category/movie/filter"
          linkLabel="按条件筛选"
        />
        <PosterGrid items={hotTitles} showRank />
      </section>

      <section className="px-4 pb-4 md:px-8">
        <div className="rounded-lg bg-primary-950 px-5 py-7 md:px-8 md:py-9">
          <div className="flex flex-wrap items-end justify-between gap-3">
            <h2 className="font-heading text-xl font-semibold text-background-50 md:text-2xl">
              为什么在<span className="text-accent-400">中文字幕在线免费看</span>找片
            </h2>
            <Link
              to="/about"
              className="group flex cursor-pointer items-center gap-1 whitespace-nowrap text-xs text-background-300 transition-colors hover:text-accent-400 md:text-sm"
            >
              了解站点说明
              <i className="ri-arrow-right-s-line text-base transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
            </Link>
          </div>

          <div className="mt-6 grid gap-4 md:grid-cols-3 md:gap-5">
            {features.map((feature) => (
              <div key={feature.title} className="rounded-lg border border-primary-800 bg-primary-900/50 px-4 py-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500/15">
                  <i className={`${feature.icon} text-lg text-accent-400`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-3 text-sm font-medium text-background-50">{feature.title}</h3>
                <p className="mt-2 text-xs leading-6 text-background-300">{feature.desc}</p>
              </div>
            ))}
          </div>

          <p className="mt-6 text-xs leading-6 text-background-400">
            说明：本站为影视内容演示站点，片源、播放与下载功能均未接入真实后台，播放区仅作展示。
          </p>
        </div>
      </section>
    </Layout>
  );
}